import { GroundFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';

interface Props {
  ground: GroundFragment;
}

function GroundInfo({ ground }: Props) {
  const { t } = useTranslate();
  return (
    <div className='GroundInfo'>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.surface')}</div>
        <div className='GroundInfo__value'>{ground.surface}</div>
      </div>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.rental')}</div>
        <div className='GroundInfo__value'>{ground.rental ?? '-'}</div>
      </div>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.size')}</div>
        <div className='GroundInfo__value'>{ground.size}</div>
      </div>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.lights')}</div>
        <div className='GroundInfo__value'>
          {ground.lights ? (
            <>
              <i className='bi bi-check-circle-fill' /> {t('ground.info.yes')}
            </>
          ) : (
            <>{t('ground.info.no')}</>
          )}
        </div>
      </div>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.cabins')}</div>
        <div className='GroundInfo__value'>
          {ground.cabins ? (
            <>
              <i className='bi bi-check-circle-fill' /> {t('ground.info.yes')}
            </>
          ) : (
            <>{t('ground.info.no')}</>
          )}
        </div>
      </div>
      <div className='GroundInfo__item'>
        <div className='GroundInfo__title'>{t('ground.info.showers')}</div>
        <div className='GroundInfo__value'>
          {ground.showers ? (
            <>
              <i className='bi bi-check-circle-fill' /> {t('ground.info.yes')}
            </>
          ) : (
            <>{t('ground.info.no')}</>
          )}
        </div>
      </div>
      {ground.contactPersonName && ground.contactPersonPhone && (
        <>
          <div className='GroundInfo__item'>
            <div className='GroundInfo__title'>{t('ground.info.contactPersonName')}</div>
            <div className='GroundInfo__value'>{ground.contactPersonName}</div>
          </div>
          <div className='GroundInfo__item'>
            <div className='GroundInfo__title'>{t('ground.info.contactPersonPhone')}</div>
            <div className='GroundInfo__value'>
              <a href={`tel:${ground.contactPersonPhone.replaceAll(' ', '')}`}>
                {ground.contactPersonPhone}
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default GroundInfo;
